import { ReactNode, RefObject } from "react";
import styled from "styled-components";
import { FloatingContext } from "@floating-ui/react";
import { Body } from "../../../body/Body";
import { ROW_HEIGHT } from "../../Select.Parts";

// TEXT

// STYLES
export const SelectionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const SelectionLabel = styled(Body)`
  display: block;
  height: ${ROW_HEIGHT}rem;
  line-height: ${ROW_HEIGHT}rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

// DATA

// TYPES
export type Props = {
  /** Configuration Props */
  name?: string; // The HTML name attribute for the hidden form input.
  rows: number; // The number of rows (usually 1 for single-select).
  label?: ReactNode; // The floating label content.
  placeholder?: ReactNode; // The placeholder text.
  search?: boolean; // Whether the search input is enabled.
  disabled?: boolean; // Whether the control is disabled.
  clearable?: boolean; // Whether to allow clearing the selection.

  /** Visual State Props */
  hasContent: boolean; // True if selection, placeholder, or searchValue exists.

  /** Selection Data */
  selection: (string | number)[]; // The current selected value (max length 1).
  getLabelForValue: (value: string | number) => string; // Function to get the display label for a value.

  /** Handlers */
  clearSelection: (e?: React.MouseEvent) => void; // Handler to clear the single selection.

  /** Refs & Floating UI Context */
  context: FloatingContext; // Floating UI context (contains .open).
  referenceId: string; // The ID for the reference element (for label association).
  buttonRef: RefObject<HTMLDivElement | null>; // Ref to the main button to return focus after clearing.

  /** Children */
  searchInput: ReactNode; // The pre-rendered SelectInput component node.
  searchInputId: string; // The ID for the search input (for label association).
};

// CONSTANTS

// FUNCTIONS

// ASSETS
